/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credit: NonNullable<unknown> }} Seat_Type_Max_DescInputs */



/**
* | output |
* | --- |
* | "Full access with more AI. Includes {credit} AI credit per month." |
*
* @param {Seat_Type_Max_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_type_max_desc = /** @type {((inputs: Seat_Type_Max_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Type_Max_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Voller Zugriff mit mehr KI. Enthält ${i?.credit} KI-Guthaben pro Monat.`)
	return /** @type {LocalizedString} */ (`Full access with more AI. Includes ${i?.credit} AI credit per month.`)
});